import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class XpressDisciplinaryService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getRidersDisciplinaries(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDisciplinary/GetRidersDisciplinaries', data, messageService);
    }

    public addOrUpdateDisciplinary(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDisciplinary/AddOrUpdateDisciplinary', data, messageService);
    }

    public getDetailDisciplinary(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDisciplinary/GetDetailDisciplinary', data, messageService);
    }

    public setInvestigativeUserAndSetStatusInvestigation(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDisciplinary/SetInvestigativeUserAndSetStatusInvestigation', data, messageService);
    }

    public saveInvestigationAndSetStatusPending(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDisciplinary/SaveInvestigationAndSetStatusPending', data, messageService);
    }

    public saveInvestigationAndSetStatusHearing(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDisciplinary/SaveInvestigationAndSetStatusHearing', data, messageService);
    }

    public saveDisciplinaryAction(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDisciplinary/SaveDisciplinaryAction', data, messageService);
    }

    public suspensionUserThirtyDays(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDisciplinary/SuspensionUserThirtyDays', data, messageService);
    }

    public saveHearingAndSetStatusPending(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDisciplinary/SaveHearingAndSetStatusPending', data, messageService);
    }

    public changePriority(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDisciplinary/ChangePriority', data, messageService);
    }
}
